export default __webpack_public_path__ + "static/media/camera.d04220f7.svg";